// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"MainLoader_loaderWrapper__fsvlb","noNav":"MainLoader_noNav__hSAOp","loader":"MainLoader_loader__CGp+z"};